export const AboutPage = () => {
  const teamMembers = [
    { name: "John Doe", role: "CEO & Founder", bio: "Leading innovation since 2020" },
    { name: "Jane Smith", role: "CTO", bio: "Technical expert with 15 years experience" },
    { name: "Mike Johnson", role: "Head of Design", bio: "Creating beautiful experiences" },
  ];

  const values = [
    { title: "Innovation", body: "Constantly pushing boundaries and embracing new technologies." },
    { title: "Excellence", body: "Delivering high-quality solutions in everything we do." },
    { title: "Integrity", body: "Building trust through honest and ethical practices." },
    { title: "Collaboration", body: "Working together to achieve exceptional results." },
  ];

  return (
    <div className="mx-auto max-w-5xl">
      <section className="mb-16 text-center">
        <h1 className="mb-4 text-4xl font-extrabold tracking-tight text-foreground sm:text-5xl">
          About Us
        </h1>
        <p className="mx-auto max-w-2xl text-xl text-muted-foreground">
          We&apos;re on a mission to make cross-border shopping effortless —
          connecting customers with PK Fashion and North American products.
        </p>
      </section>

      <section className="mb-16 rounded-lg border border-border bg-card p-8">
        <h2 className="mb-4 text-2xl font-bold text-foreground">Our Mission</h2>
        <p className="text-lg leading-relaxed text-muted-foreground">
          To provide exceptional value through a seamless shopping experience that
          empowers customers to buy across borders with confidence.
        </p>
      </section>

      <section className="mb-16">
        <h2 className="mb-8 text-2xl font-bold text-foreground">Our Team</h2>
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {teamMembers.map((member) => (
            <div key={member.name} className="rounded-lg border border-border bg-card p-6">
              <h3 className="mb-2 text-xl font-semibold text-foreground">{member.name}</h3>
              <p className="mb-4 text-lg font-medium text-primary">{member.role}</p>
              <p className="text-muted-foreground">{member.bio}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="rounded-lg border border-border bg-card p-8">
        <h2 className="mb-6 text-2xl font-bold text-foreground">Our Values</h2>
        <div className="grid gap-8 sm:grid-cols-2">
          {values.map((value) => (
            <div key={value.title}>
              <h3 className="mb-2 text-xl font-semibold text-foreground">{value.title}</h3>
              <p className="text-muted-foreground">{value.body}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
